import { HapticService } from './../../services/haptic-service/haptic.service'
import { Component, forwardRef, inject, input, linkedSignal, output } from '@angular/core'
import type { ControlValueAccessor } from '@angular/forms'
import { NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
  selector: 'aw-switch-button-old',
  templateUrl: './switch-button.component.html',
  styleUrls: ['./switch-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SwitchButtonComponent)
    }
  ]
})
export class SwitchButtonComponent implements ControlValueAccessor {
  private hapticService = inject(HapticService)

  /** Use only the visual track inside a parent switch control. */
  readonly presentation = input(false)
  readonly ariaLabel = input<string>()
  readonly value = input(false)
  readonly disabled = input(false)

  readonly changed = output<boolean>()

  readonly valueState = linkedSignal(() => this.value())
  readonly disabledState = linkedSignal(() => this.disabled())

  /** Reports a user toggle while keeping programmatic writes silent. */
  clicked(): void {
    if (!this.disabledState() && !this.presentation()) {
      this.valueState.set(!this.valueState())
      this.hapticService.buttonClick()
      this.onChange(this.valueState())
      this.onTouched()
      this.changed.emit(this.valueState())
    }
  }

  // --------------------------------ControlValueAccessor Implementation-----------------------------------------

  // Function to call when the rating changes.
  onChange = (value: boolean) => {}

  // Function to call when the input is touched (when a star is clicked).
  onTouched = () => {}

  // Update the model and changes needed for the view here.
  writeValue(value: boolean): void {
    this.valueState.set(value)
  }

  // Allows Angular to register a function to call when the model changes.
  // Save the function as a property to call later here.
  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn
  }

  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }

  // Allows Angular to disable the input.
  setDisabledState(isDisabled: boolean): void {
    this.disabledState.set(isDisabled)
  }
}
